import { type CSSProperties } from '@mui/material/styles/createMixins';

export const borderRadius_7: CSSProperties = { borderRadius: '7px' };
export const borderRadius_10: CSSProperties = { borderRadius: '10px' };
